import * as React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {mq} from '../../../../utils/breakpoints'

type PropsType = {
  /** Add a margin at the bottom's card */
  bottomSpacing?: boolean

  /** Card content */
  children?: React.ReactNode

  /** Whether card should have a hover effect */
  hasHoverEffect?: boolean

  /** Whether card should have rounded corners at the top */
  hasRoundedBottom?: boolean

  /** Whether card should have rounded corners at the bottom */
  hasRoundedTop?: boolean

  /** Whether card should have shadow */
  hasShadow?: boolean

  /** Whether card should have a highlighted effect */
  highlighted?: boolean

  /** Whether overflowing content of the card should be hidden */
  overflowHidden?: boolean
}

const CardElement = styled('div')(({theme, ...props}) => {
  const {
    hasHoverEffect,
    hasShadow,
    highlighted,
    hasRoundedBottom,
    hasRoundedTop,
    bottomSpacing,
    overflowHidden
  } = props

  return css`
    background: ${theme.colors.defaultBg};
    box-shadow: ${theme.shadows.action};
    transition: box-shadow 0.1s ease-in-out;

    ${
      overflowHidden &&
      css`
        overflow: hidden;
      `
    }

    ${
      hasRoundedBottom &&
      css`
        border-bottom-left-radius: ${theme.layout.radius.lg}px;
        border-bottom-right-radius: ${theme.layout.radius.lg}px;

        ${mq.desktopXs(css`
          border-bottom-left-radius: ${theme.layout.radius.md}px;
          border-bottom-right-radius: ${theme.layout.radius.md}px;
        `)}
      `
    }

      ${
        hasRoundedTop &&
        css`
          border-top-left-radius: ${theme.layout.radius.lg}px;
          border-top-right-radius: ${theme.layout.radius.lg}px;

          ${mq.desktopXs(css`
            border-top-left-radius: ${theme.layout.radius.md}px;
            border-top-right-radius: ${theme.layout.radius.md}px;
          `)}
        `
      }

      ${
        hasHoverEffect &&
        css`
          &:hover {
            box-shadow: ${theme.shadows.floating};
          }
        `
      }

      ${
        highlighted &&
        css`
          box-shadow: ${theme.shadows.anchorHover};

          ${hasHoverEffect &&
          css`
            &:hover {
              box-shadow: ${theme.shadows.anchor};
            }
          `}
        `
      }

      ${
        !hasShadow &&
        css`
          box-shadow: none;

          &:hover {
            box-shadow: none;
          }
        `
      }

      ${
        bottomSpacing &&
        css`
          margin-bottom: ${theme.layout.spacing.s500}px;
        `
      }
  `
})

const Card = (props: PropsType) => {
  const {children} = props
  return <CardElement {...props}>{children}</CardElement>
}

Card.defaultProps = {
  hasRoundedTop: true,
  hasRoundedBottom: true,
  hasHoverEffect: true,
  hasShadow: true
}

export default Card
